// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--IHkK8","feature":"a2c79c7e7d--feature--I0BEu","text":"a2c79c7e7d--text--GDKqt","feature-img":"a2c79c7e7d--feature-img--hstIi"};